import type Victor from 'victor';
import type { INodeShape } from '@model-framework/shape/INodeShape';

/**
 * リンクの線を引く区間の始点・終点を返す。
 *
 * 端点は要素の枠そのものではなく、offset だけ外側へ離した位置に置かれる。
 * リンクの描画（LinkPlacement）と、ラベル位置の検査（viewQualityChecks）の両方がこの結果を
 * 前提にしているため、片方だけがずれないよう共通の関数にしている。
 */
export function linkStartEndPoints(
  fromCenter: Victor,
  toCenter: Victor,
  fromShape: INodeShape,
  toShape: INodeShape,
  offset: number
): [Victor, Victor] {
  const fromToDirection = toCenter.clone().subtract(fromCenter);

  return [
    fromShape.getBorderPoint(fromToDirection, offset).add(fromCenter),
    toShape.getBorderPoint(fromToDirection.clone().invert(), offset).add(toCenter),
  ];
}
